module.exports = __webpack_public_path__ + "assets/close-816aa8d6dac1d9b3bc7be7e66b5d5566.svg";